import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { extractHost } from "utils/urls";

type FlowsDetailsDrawerProps = {
  baseURL: string;
  organizationName: string;
  createdAt: number;
  updatedAt: number;
};

const FlowsDetailsDrawer = createDrawer(
  ({ baseURL, organizationName, createdAt, updatedAt }: FlowsDetailsDrawerProps) => {
    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Details" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <FormFieldViewText label="Instance" value={extractHost(baseURL)} />
          <FormFieldViewText label="Organization name" value={organizationName} />
          <FormFieldTimestamp label="Created at" timestamp={createdAt} />
          <FormFieldTimestamp label="Updated at" timestamp={updatedAt} />
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showFlowsDetailsDrawer = createDrawerTrigger(FlowsDetailsDrawer);
